import { Component, OnInit, Input } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

import { commentsType, emptyFields } from '../../utilities/common-file';
import { NzTableData } from '../../utilities/nz-table.adapter';
import { SettlementService } from '../../settlements/settlements.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommentSearch } from '../../../app/models/comments';
import { CommonService } from '../../utilities/common-service';

@Component({
    selector: 'app-settlement-comments',
    templateUrl: './comments.component.html',
  })
  export class SettlementCommentsComponent implements OnInit {
    loading = false;
    emptyField = emptyFields;
    commentsForm: UntypedFormGroup;
    @Input() selectedTransaction: any;
    selectedUser: any;
    showCheckBox = false;
    loadingForSave = false;
    private tableData: NzTableData<CommentSearch, any> = new NzTableData<CommentSearch,
    any>(new CommentSearch(), 'transactionStatus');
    constructor(private fb: UntypedFormBuilder, private drawerRef: NzDrawerRef<string>,
                private transactionService: SettlementService, private notification: NzNotificationService,
                private commonService: CommonService) {
        this.commentsForm = this.fb.group({
            comments: ['', Validators.required]
        });
    }
ngOnInit() {
    this.commentsForm.reset();
    this.getComments();
}
saveComments() {
    if (this.commentsForm.value.comments) {
        this.loadingForSave = true;
        const commentsValue = {
          referenceId: this.selectedTransaction.id,
          comment: this.commentsForm.value.comments,
          type: commentsType.merchantSettlement
        };
        this.commonService.createComments(commentsValue).subscribe((response: any) => {
          this.loadingForSave = false;
          this.notification.success(response.message, '', {
            nzKey : 'key'
          });
          this.commentsForm.reset();
          this.getComments();
        }, (errComments: any) => {
          this.loadingForSave = false;
          this.notification.error(errComments.message, '', {
            nzKey : 'key'
          });
        });
} else {
    // tslint:disable-next-line: forin
    for (const i in this.commentsForm.controls) {
        this.commentsForm.controls[i].markAsDirty();
        this.commentsForm.controls[i].updateValueAndValidity();
      }
    this.notification.error('Please fill comments', '', {
        nzKey: 'key'
    });
}
}
getComments(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.tableData.search.referenceId = this.selectedTransaction.id,
    this.tableData.search.type = commentsType.merchantSettlement;
    this.commonService.getCommentsWithLimit(this.tableData).subscribe((response: any) => {
      this.loading = false;
      this.tableData.total = response.data.total;
      this.tableData.data = response.data.comments;
      }, (err) => {
        this.loading = false;
        this.tableData.data = [];
      });
}
onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.getComments(false);
}
close() {
    this.drawerRef.close();
}
getUserType(role) {
  return this.commonService.getUserType(role);
}
}
